import { createEffect, createStore } from "effector";

export const fetchTelegramAuth = createEffect(async () => {
  if (import.meta.env.VITE_JWT_TEST_TOKEN != "production") {
    return {
      id: "8",
      username: "HackneyTest",
      firstName: "Hack",
      lastName: "Ney",
    };
  }

  const accessToken = await window.HackneyGamesSDK.telegramAuthId();

  let playerProfile: PlayerProfile | null = null;

  if (accessToken) {
    const user = window.Telegram.WebApp.initDataUnsafe.user;

    if (user) {
      playerProfile = {
        id: user.id,
        username: user.username,
        firstName: user.first_name,
        lastName: user.last_name,
      };
    }
  }

  return playerProfile;
});

export type PlayerProfile = {
  id: string;
  username?: string;
  firstName: string;
  lastName?: string;
};

export const $playerProfile = createStore<PlayerProfile | null>(null).on(
  fetchTelegramAuth.doneData,
  (currUserProfile, newUserProfile) => newUserProfile || currUserProfile,
);
